export enum LessorCertificateEnum {
  Social = 'Social',
  Private = 'Privé',
  Yes = 'Oui',
  No = 'Non'
}
